'use client';

import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import SideNav from './SideNav';
import GlobalSearch from './GlobalSearch';
import { Logo } from '@/components/ui';

export default function Header({ onMenuClick }: { onMenuClick?: () => void } = {}) {
  const [open, setOpen] = useState(false);
  const t = useTranslations('Nav');

  useEffect(() => {
    if (open) {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [open]);

  return (
    <header className="top-0 z-40 w-full">
      <div className="flex h-14 items-center justify-between sm:px-6">
        <Logo size="lg" />
        <button
          type="button"
          aria-label="Open menu"
          className="border-border hover:bg-foreground/[0.06] inline-flex h-9 w-9 flex-col items-center justify-center rounded-md border md:hidden"
          onClick={onMenuClick || (() => setOpen(true))}
        >
          {/* Hamburger */}
          <span className="block h-0.5 w-4 bg-current" />
          <span className="mt-1 block h-0.5 w-4 bg-current" />
          <span className="mt-1 block h-0.5 w-4 bg-current" />
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 md:hidden" role="dialog" aria-modal="true">
          <div
            className="bg-foreground/50 absolute inset-0"
            onClick={() => setOpen(false)}
            aria-hidden
          />
          <div className="bg-card absolute top-0 left-0 h-full w-72 max-w-[80%] p-4 shadow-lg">
            <div className="mb-2 flex items-center justify-between">
              <span className="font-semibold">{t('menu')}</span>
              <button
                type="button"
                aria-label="Close menu"
                className="border-border hover:bg-foreground/[0.06] inline-flex h-8 w-8 items-center justify-center rounded-md border"
                onClick={() => setOpen(false)}
              >
                <span className="block h-0.5 w-3.5 -translate-y-0.5 rotate-45 bg-current" />
                <span className="block h-0.5 w-3.5 translate-y-0.5 -rotate-45 bg-current" />
              </button>
            </div>

            {/* Mobile search */}
            <div className="mb-4">
              <GlobalSearch />
            </div>

            <SideNav />
          </div>
        </div>
      )}
    </header>
  );
}
